import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ExternalLink, FileText } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "@tanstack/react-router";
import { useState } from "react";

interface TermsAcknowledgmentDialogProps {
  open: boolean;
  onClose: () => void;
}

export function TermsAcknowledgmentDialog({
  open,
  onClose,
}: TermsAcknowledgmentDialogProps) {
  const [isAcknowledged, setIsAcknowledged] = useState(false);

  const handleAcknowledge = () => {
    if (isAcknowledged) {
      // Store in localStorage that user has acknowledged the terms
      localStorage.setItem("termsAcknowledged", "true");
      onClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-primary" />
            Updated Terms & Conditions
          </DialogTitle>
          <DialogDescription className="text-left">
            Please make sure you've read our latest{" "}
            <Link
              to="/terms"
              className="inline-flex items-center gap-1 font-medium text-primary underline underline-offset-4 hover:text-primary/80"
              target="_blank"
              rel="noopener noreferrer"
            >
              terms and conditions
              <ExternalLink className="h-3 w-3" />
            </Link>
            . By submitting a piece of content moving forward, you agree to
            subscribe to those T&Cs.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="terms-acknowledge"
            checked={isAcknowledged}
            onCheckedChange={(checked) => setIsAcknowledged(checked as boolean)}
          />
          <label
            htmlFor="terms-acknowledge"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            I acknowledge that I have read and agree to the updated Terms &
            Conditions
          </label>
        </div>
        <DialogFooter>
          <Button onClick={handleAcknowledge} disabled={!isAcknowledged}>
            I Understand
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
